const TextLeftInActive = ({ quat }) => {
   return (
      <>
         <svg width="210" height="177" viewBox="0 0 210 177" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="175.545" x2="210" y2="175.545" stroke="url(#paint0_linear_66_551_ltin)" strokeWidth="1.56134" />
            <path d="M97.0312 46.7321L178.446 93.7405L178.447 112.018L97.0323 65.0096L97.0312 46.7321Z" fill="#6E6E6E" />
            <path d="M15.6154 93.7387L97.0305 46.7303L97.0294 65.0078L15.6144 112.016L15.6154 93.7387Z" fill="#6E6E6E" />
            <rect width="94.0117" height="94.0117" transform="matrix(0.866041 0.499972 -0.866041 0.499972 97.0312 64.3547)" fill="#AAAAAA" />
            <path d="M15.6145 93.7335L97.0295 140.742L97.0306 158.367L15.6155 111.358L15.6145 93.7335Z" fill="url(#paint1_linear_66_551_ltin)" />
            <path d="M97.0317 140.74L178.447 93.7316L178.446 111.356L97.0307 158.365L97.0317 140.74Z" fill="url(#paint2_linear_66_551_ltin)" />
            <rect x="0.866041" width="93.0117" height="93.0117" transform="matrix(0.866041 -0.499972 0.866041 0.499972 15.7305 94.1699)" fill="url(#paint3_linear_66_551_ltin)" stroke="url(#paint4_linear_66_551_ltin)" />
            <text transform="matrix(0.86601 0.500028 3.18351e-05 1 64.0149 0.675049)" fill="white" xmlSpace="preserve" style={{ whiteSpace: "pre" }}  fontSize="58.5502" fontWeight="800" letterSpacing="0em">
               <tspan x="0" y="56.791">{quat}</tspan>
            </text>
            <g opacity="0.3" filter="url(#filter0_f_66_551_ltin)">
               <ellipse cx="94.9914" cy="98.3072" rx="37" ry="6" transform="rotate(25.4307 94.9914 98.3072)" fill="black" />
            </g>
            <defs>
               <filter id="filter0_f_66_551_ltin" x="47.4758" y="67.5155" width="95.0312" height="61.5834" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur_66_551" />
               </filter>
               <linearGradient id="paint0_linear_66_551_ltin" x1="0" y1="176.826" x2="210" y2="176.826" gradientUnits="userSpaceOnUse">
                  <stop stopColor="white" stopOpacity="0.47" />
                  <stop offset="1" stopColor="#020202" />
               </linearGradient>
               <linearGradient id="paint1_linear_66_551_ltin" x1="56.3223" y1="117.238" x2="48.6905" y2="130.455" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#262626" />
                  <stop offset="1" stopColor="#383838" />
               </linearGradient>
               <linearGradient id="paint2_linear_66_551_ltin" x1="137.739" y1="117.236" x2="145.371" y2="130.454" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#262626" />
                  <stop offset="1" stopColor="#383838" />
               </linearGradient>
               <linearGradient id="paint3_linear_66_551_ltin" x1="47.0059" y1="0" x2="47.0059" y2="94.0117" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#262626" />
                  <stop offset="1" stopColor="#383838" />
               </linearGradient>
               <linearGradient id="paint4_linear_66_551_ltin" x1="58.6424" y1="-10.3787" x2="-28.8752" y2="58.2269" gradientUnits="userSpaceOnUse">
                  <stop offset="0.561269" stopColor="#282828" />
                  <stop offset="1" stopColor="white" />
               </linearGradient>
            </defs>
         </svg>
      </>
   )
}
export default TextLeftInActive;